import { render, staticRenderFns } from "./EditPromotionModal.vue?vue&type=template&id=6190f3b7"
import script from "./EditPromotionModal.vue?vue&type=script&lang=js"
export * from "./EditPromotionModal.vue?vue&type=script&lang=js"
import style0 from "./EditPromotionModal.vue?vue&type=style&index=0&id=6190f3b7&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports